module.exports = __webpack_public_path__ + "media/images/signups/card/idv-failure-6c03978c182d4a61164731468e53bba1.png";